module.exports = __webpack_public_path__ + "static/str1-7baa67953ca1fcd7cdc8e6094e7a2dfc.jpg";